import { Check } from "lucide-react";
import { useResponsive } from "@design-lab/shared/hooks/useResponsive";

const EXPERT_EDIT_FEATURES = [
  "<24 hour turnaround",
  "Change color",
  "Direct print, fast delivery",
  "Add text",
  "Background removal"
];

// Mobile has different order of features
const MOBILE_EXPERT_EDIT_FEATURES = [
  "<24 hour turnaround",
  "Direct print, fast delivery",
  "Background removal",
  "Change color",
  "Add text"
];

export function ExpertEditFeatures() {
  const { isDesktop } = useResponsive();

  const features = isDesktop ? EXPERT_EDIT_FEATURES : MOBILE_EXPERT_EDIT_FEATURES;

  return (
    <div className="space-y-3 lg:pt-2">
      <p className="text-left text-base font-bold lg:text-center lg:text-lg">
        What else do you get with Expert Edit?
      </p>
      <div className="lg:grid lg:grid-cols-2 lg:gap-2">
        {features.map(feature => (
          <div
            className="mb-4 flex items-center gap-2 text-base font-normal text-gray-900 lg:mb-0 lg:text-xl"
            key={feature}
          >
            <Check className="size-8 stroke-green-500" />
            <p>{feature}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
